/* tslint:disable */
type Unit =
  'CURRENCY' |
  'PERCENT' |
  'NUMBER' |
  'DURATION';
namespace Unit {
  export const CURRENCY: Unit = 'CURRENCY';
  export const PERCENT: Unit = 'PERCENT';
  export const NUMBER: Unit = 'NUMBER';
  export const DURATION: Unit = 'DURATION';
  export function values(): Unit[] {
    return [
      CURRENCY,
      PERCENT,
      NUMBER,
      DURATION
    ];
  }
}

export { Unit }
